/**
 * Prevents double submits of EXT:form forms: the submit button is locked and gets a
 * spinner as soon as the form is sent, and is unlocked again when the visitor comes back
 * via the browser history.
 */
const SUBMITTING_CLASS = 'is-submitting'

const forms = document.querySelectorAll('.form-container form')

const getButtons = form => form.querySelectorAll('.form-navigation button')

const lock = (form, submitter) => {
  // The submit button carries __currentPage as its name/value and a disabled button is
  // left out of the payload - so mirror it into a hidden field before locking.
  if (submitter && submitter.name) {
    const mirror = document.createElement('input')
    mirror.type = 'hidden'
    mirror.name = submitter.name
    mirror.value = submitter.value
    mirror.dataset.submitGuardMirror = 'true'
    form.appendChild(mirror)
  }

  form.dataset.submitting = 'true'
  form.setAttribute('aria-busy', 'true')

  getButtons(form).forEach(button => {
    button.setAttribute('aria-disabled', 'true')
    button.classList.add(SUBMITTING_CLASS)
  })

  if (submitter) {
    const spinner = document.createElement('span')
    spinner.className = 'spinner-border spinner-border-sm ml-2'
    spinner.dataset.submitGuardSpinner = 'true'
    spinner.setAttribute('aria-hidden', 'true')
    submitter.appendChild(spinner)
  }

  // disable only after the browser has serialised the form
  window.setTimeout(() => {
    getButtons(form).forEach(button => {
      button.disabled = true
    })
  }, 0)
}

const unlock = form => {
  delete form.dataset.submitting
  form.removeAttribute('aria-busy')

  getButtons(form).forEach(button => {
    button.disabled = false
    button.removeAttribute('aria-disabled')
    button.classList.remove(SUBMITTING_CLASS)
  })

  form.querySelectorAll('[data-submit-guard-spinner]').forEach(spinner => spinner.remove())
  form.querySelectorAll('[data-submit-guard-mirror]').forEach(mirror => mirror.remove())
}

const isSubmitting = form => form.dataset.submitting === 'true'

forms.forEach(form => {
  form.addEventListener('submit', event => {
    if (isSubmitting(form)) {
      event.preventDefault()
      return
    }

    lock(form, event.submitter)
  })

  // The "previous page" button submits via form.submit(), which fires no submit event.
  form.querySelectorAll('button.btn-cancel').forEach(button => {
    button.addEventListener('click', event => {
      if (isSubmitting(form)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        return
      }

      lock(form, button)
    })
  })
})

// restore a usable form when the page comes back from the browser cache
window.addEventListener('pageshow', event => {
  if (event.persisted) {
    forms.forEach(unlock)
  }
})
